import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ContentBorderShadowUIComponent } from '../../content-border-shadow/content-border-shadow.component';

@Component({
  selector: 'fr8bot-business-view-tab',
  imports: [ContentBorderShadowUIComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './business-view-tab.component.html',
  styleUrl: './business-view-tab.component.scss',
})
export class BusinessViewTabComponent {
  variantModal = input(false);
}
